import { render, staticRenderFns } from "./publisher-info.html?vue&type=template&id=1d08a39c&scoped=true&external"
import script from "./publisher-info.js?vue&type=script&lang=js&external"
export * from "./publisher-info.js?vue&type=script&lang=js&external"
import style0 from "./publisher-info.scss?vue&type=style&index=0&id=1d08a39c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08a39c",
  null
  
)

export default component.exports